import { render, staticRenderFns } from "./business.vue?vue&type=template&id=3bb40a53&scoped=true&"
import script from "./business.vue?vue&type=script&lang=ts&"
export * from "./business.vue?vue&type=script&lang=ts&"
import style0 from "./business.vue?vue&type=style&index=0&id=3bb40a53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb40a53",
  null
  
)

export default component.exports